import {Component, OnDestroy, OnInit} from '@angular/core';
import {FrtEditRatesAccessorialsComponent} from '../frt-edit-rates-accessorials/frt-edit-rates-accessorials.component';
import {
  ReactiveFormsModule,
  UntypedFormArray,
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators
} from '@angular/forms';
import {FrtRateEditService} from 'src/app/services/frt-rate-edit/frt-rate-edit.service';
import {LoadingService} from '../../services/loading/loading.service';
import {AlertService} from '../../services/alert/alert.service';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import {ConfirmationModalComponent} from '../../shared/common-components/confirmation-modal/confirmation-modal.component';
import {UserService} from '../../services/user/user.service';
import {User} from '../../services/user/user';
import {
  FrtServicesMaster,
  RatesFrtProcure,
  RatesFrtProcureEdit,
  RatesSroMaster,
  StateCountry
} from 'src/app/shared/common-components/common-structure';
import {DateFormatPipe} from '../hhg-rate-edit/my-date-formatter';
import {HhgCarrierRateFilingService} from '../hhg-carrier-rate-filing/hhg-carrier-rate-filing.service';
import {ltlMinChargeValidator, ltlSurChargeValidator, tlMinChargeValidator, tlRateAmountValidator} from './Validators';
import { BehaviorSubject } from 'rxjs';
import { CarrierService } from 'src/app/services/carrier/carrier.service';
import { takeWhile } from 'rxjs/operators';
import AppConstants from '../../shared/common-components/AppConstants';
import {PaginationComponent} from "../../shared/pagination/pagination.component";


@Component({
    selector: 'app-frt-rate-edit',
    templateUrl: './frt-rate-edit.component.html',
    styleUrls: ['./frt-rate-edit.component.css'],
    imports: [ReactiveFormsModule, PaginationComponent]
})
export class FrtRateEditComponent implements OnInit, OnDestroy {
  frtViewRatesFormGroup: UntypedFormGroup;
  status = [];
  sroIdList: RatesSroMaster[] = [];
  originList: StateCountry[] = [];
  destinationList: StateCountry[] = [];
  headerElements = [];
  elements = [];
  showTable: boolean;
  modalRef: BsModalRef;
  bsModalRef: BsModalRef;
  private tmssloader;
  currentUser: User | any;
  carrierId: any;
  sroMasterId: any;
  scac: string;
  frtMasterList: FrtServicesMaster[] = [];
  ltlMaximumChargePct: number;
  ltlMinimumChargePct: number;
  tlMinimumCharge: number;
  tlMaximumCharge: number;
  // public overlayNoRowsTemplate;
  private gridApi;
  // frtRatesResultsGridOptions: GridOptions = this.initializeGridOptions();
  // columnDefs: any;
  headElementsLtl = ['Delete', 'Status', 'Date',
    'Origin', 'Destination', 'Tender ID',
    'LTL surcharge', 'Surcharge limit', 'LTL Minimum Charge', 'Min charge Limit'];
  headElementsTl = ['Delete', 'Status', 'Date',
    'Origin', 'Destination', 'Tender ID',
    'TL Rate Amount', 'Rate Amt Limit', 'TL Minimum Charge', 'Min Charge Limit'];
  statusList: string[] = [
    'All',
    'Modified',
    'New',
    'Unchanged'
  ];
  ratesFrtProcureEditList: RatesFrtProcureEdit[] = [];
  ratesFrtUpdateList: RatesFrtProcure[];
  ratesFrtDeleteArray: number[];
  editButtonText = 'Update';
  updateBtnEnable = false;
  itemsPerPage = 10;
  totalItems = 0;
  currentPage = 1;
  pageReset = false;
  previousPage = 0;
  resultsPage: any = null;
  pageMap: Map<number, any> = new Map<number, any>();
  showingStart: number;
  showingEnd: number;
  rate18: boolean;
  totalPages = 0;

  observer$ = new BehaviorSubject(true);
  ratesBidcyclesId;

  constructor(private fb: UntypedFormBuilder,
              private frtRateEditService: FrtRateEditService,
              public loader: LoadingService,
              private alertService: AlertService,
              private userService: UserService,
              private hhgService: HhgCarrierRateFilingService,
              private hhgrateService: HhgCarrierRateFilingService,
              private carrierService: CarrierService,
              private modalService: BsModalService) {
    this.tmssloader = this.loader;
    this.userService.getCurrentUserObservable().pipe(takeWhile(() => this.observer$.value)).subscribe(currentUser => {
      this.currentUser = currentUser;
    });
  }

  ngOnInit() {
    this.initializeFrtForm();
    this.hhgService.getCarrierIdByUser()
   .pipe(takeWhile(() => this.observer$.value))
   .subscribe(carrierId => {
     this.carrierId = carrierId;
     this.carrierService.getRateBidCycleId()
       .pipe(takeWhile(() => this.observer$.value))
       .subscribe(res => {
         this.ratesBidcyclesId = res.ratesBidcyclesId;
         this.hhgrateService.getFrtBidCycleAgencies(this.carrierId, this.ratesBidcyclesId)
           .pipe(takeWhile(() => this.observer$.value))
           .subscribe(res1 => {
             this.tmssloader.hide();
             this.sroIdList = res1 as RatesSroMaster[];
           }, error => {
             this.tmssloader.hide();
             this.alertService.error('Unable to load Sro Types value. Please try again later or contact system administrator');
           });
       }, error => {
         this.tmssloader.hide();
         this.alertService.error('Unable to load rates bidcycles id  value. Please try again later or contact system administrator');
       });
   }, error => {
     this.tmssloader.hide();
     this.alertService.error('Unable to load TSP info values. Please try again later or contact system administrator');
   });

  }

  /**
   * @description initializes the FRT form
   */
  initializeFrtForm() {
    this.frtViewRatesFormGroup = this.fb.group({
      rateType: new UntypedFormControl(''),
      sroId: new UntypedFormControl(''),
      origin: new UntypedFormControl(''),
      destination: new UntypedFormControl(''),
      status: new UntypedFormControl(''),
      rateTableControls: this.fb.array([])
    });
  }

  /**
   * @description listens to changes in the rate type form control and displays the content accordingly.
   */
  onRateTypeChange() {
    this.showTable = false;
    this.headerElements = [];
    this.getFormField('sroId').setValue('');
    this.getFormField('origin').setValue('');
    this.getFormField('destination').setValue('0');
    this.getFormField('status').setValue('A');
    this.editButtonText = 'Update';
    const rateType = this.getFormField('rateType').value;
    if (rateType !== '') {
      this.frtRateEditService.getSrosByBidcycle(rateType, this.ratesBidcyclesId, this.carrierId)
        .pipe(takeWhile(() => this.observer$.value))
        .subscribe(allSros => {
        this.sroIdList = allSros;
      }, error => {
        this.alertService.error('There was an error retrieving SRO List');
      });
      if (rateType === '18' || rateType === '20' || rateType === '21' || rateType === '22' || rateType === '23' || rateType === '24'
          || rateType === '25') {
        this.headerElements = this.headElementsTl;
        // this.columnDefs = this.rateListQueryResultColumnDefs('TL');
        this.rate18 = true;
      } else {
        this.headerElements = this.headElementsLtl;
        // this.columnDefs = this.rateListQueryResultColumnDefs('LTL');
        this.rate18 = false;
      }
    } else {
      this.showTable = false;
      this.headerElements = [];
    }
  }

  /*
* @description getFormField for frtRateGlobalUpdateFormGroup
* */
  getFormField(field: string): any {
    return this.frtViewRatesFormGroup.get(field);
  }

  /*
  * @description : onSroChange() listens to SRO changes from the selection
  * criteria
  */
  onSroChange($event) {
    this.showTable = false;
    this.getFormField('origin').setValue('');
    this.getFormField('destination').setValue('0');
    this.getFormField('status').setValue('A');

    this.sroMasterId = this.getFormField('sroId').value;
    const sroId = this.getFormField('sroId').value;
    if (AppConstants.isNotNullCondition(this.getFormField('rateType').value) && AppConstants.isNotNullCondition(sroId)) {
      this.frtRateEditService.getOrigDestBySroIds(sroId)
        .pipe(takeWhile(() => this.observer$.value))
        .subscribe(allOrigDest => {
        this.originList = allOrigDest.filter(origin => origin.businessType.toLowerCase().indexOf('frt') > -1);
        // this.destinationList = allOrigDest; // should have unique destination
      }, error => {
        this.alertService.error('There was an error retrieving Origin List');
      });
    }

  }

  /*
  *@description : onOriginChange() listens to origin changes from the selection
  * criteria
  */
  onOriginChange($event) {
    const sroId = this.getFormField('sroId').value;
    const originId = this.getFormField('origin').value;
    if (AppConstants.isNotNullCondition(originId) && AppConstants.isNotNullCondition(sroId)) {
      this.frtRateEditService.getDestByOriginBySro(sroId, originId)
        .pipe(takeWhile(() => this.observer$.value))
        .subscribe((allOrigDest: any) => {
          this.destinationList = allOrigDest.filter((origin: any) => origin.businessType.toLowerCase().indexOf('frt') > -1); // should have unique destination
        }, error => {
          this.alertService.error('There was an error retrieving Destination List');
        });
      }
    this.showTable = false;
    this.getFormField('destination').setValue('0');
    this.getFormField('status').setValue('A');
    if ((this.getFormField('rateType').value !== '') &&
      (this.getFormField('sroId').value !== '') &&
      (this.getFormField('origin').value !== '')) {
      this.tmssloader.show();
      this.search();
    }
  }

  /*
  *@description : onDestinationChange() listens to destination changes from the selection
  * criteria
  */
  onDestinationChange($event) {
    this.showTable = false;
    if ((this.getFormField('rateType').value !== '') &&
      (this.getFormField('sroId').value !== '') &&
      (this.getFormField('origin').value !== '')) {
      this.tmssloader.show();
      this.search();
    }
  }

  /*
  *@description : onStatusChange() listenes to status changes from the selection
  * criteria
  */
  onStatusChange($event) {
    this.showTable = false;
    if ((this.getFormField('rateType').value !== '') &&
      (this.getFormField('sroId').value !== '') &&
      (this.getFormField('origin').value !== '')) {
      this.tmssloader.show();
      this.search();
    }
  }

  /*
  * @description : search() function populates the data table with FRT procure rates.
  *This is executed when user makes selection atleast on Rate Type,SRO and Origin.
  */
  search() {
    this.ratesFrtDeleteArray = [];
    this.ratesFrtUpdateList = [];
    if ((this.getFormField('rateType').value !== '') &&
      (this.getFormField('sroId').value !== '') &&
      (this.getFormField('origin').value !== '')) {
      this.frtRateEditService.getAllRatesList(this.carrierId, this.getFormField('rateType').value,
        this.getFormField('sroId').value, this.getFormField('origin').value,
        this.getFormField('destination').value, this.ratesBidcyclesId, this.getFormField('status').value
      ).subscribe(allRatesFrtProcure => {
        this.ratesFrtProcureEditList = allRatesFrtProcure;
        this.totalItems = this.ratesFrtProcureEditList.length;
        if (this.totalItems > 0) {
          this.showTable = true;
          this.setupPagination();
        } else {
          while ((<UntypedFormArray>this.frtViewRatesFormGroup.get('rateTableControls')).length !== 0) {
            (<UntypedFormArray>this.frtViewRatesFormGroup.get('rateTableControls')).removeAt(0);
          }
          this.alertService.info('There are no rate records for this selection criteria!!!');
        }
        this.tmssloader.hide();
      }, error => {
        this.tmssloader.hide();
        this.alertService.error('There was an error retrieving Rates Frt  Procure');
      });
    }
  }

  /*
  * listenes to Delete Select/unselect event
  */
  onSelectDelete(isChecked: boolean, procureId: number) {
    if (isChecked) {
      this.ratesFrtDeleteArray.push(procureId);
    } else {
      const index: number = this.ratesFrtDeleteArray.indexOf(procureId);
      if (index !== -1) {
        this.ratesFrtDeleteArray.splice(index, 1);
      }
    }
    if (this.ratesFrtDeleteArray.length > 0) {
      this.editButtonText = 'Delete';
    } else {
      this.editButtonText = 'Update';
    }

  }

  /*
  * helper function to choose between Delete or Update based on the user activity.
  */
  edit() {
    if (this.ratesFrtDeleteArray.length > 0) {
      this.delete();
    }
    if (this.ratesFrtUpdateList.length > 0) {
      this.update();
    }
  }

  /*
  * Deletes the selected records.
  */
  delete() {
    if (this.ratesFrtDeleteArray !== null) {
      this.modalRef = this.modalService.show(ConfirmationModalComponent);
      this.modalRef.content.question = 'Are you sure, you want to delete these rate records?';
      this.modalRef.content.title = 'USER DELETE';
      this.modalRef.content.confirmText = 'Yes';
      this.modalRef.content.cancelText = 'No';
      this.modalRef.content.emitData.subscribe(result => {
        if (result.obj === true) {
          this.tmssloader.show();
          this.frtRateEditService.deleteRatesFrtProcure(this.ratesFrtDeleteArray)
            .pipe(takeWhile(() => this.observer$.value))
            .subscribe(response => {
            this.search();
            this.tmssloader.hide();
            this.alertService.info(response.response);
          });
        }
      });
    }
  }

  /*
  * If there are any value changes , those records will be updated
  */
  update() {
    if (this.ratesFrtUpdateList !== null) {
      this.modalRef = this.modalService.show(ConfirmationModalComponent);
      this.modalRef.content.question = 'Are you sure, you want to update these rate records?';
      this.modalRef.content.title = 'USER UPDATE';
      this.modalRef.content.confirmText = 'Yes';
      this.modalRef.content.cancelText = 'No';
      this.modalRef.content.emitData.subscribe(result => {

        if (result.obj === true) {
          this.tmssloader.show();
          this.frtRateEditService.updateRatesFrtProcure(this.ratesFrtUpdateList)
            .pipe(takeWhile(() => this.observer$.value))
            .subscribe(response => {
            this.search();
            this.tmssloader.hide();
            this.alertService.info(response.response);
          });

        }
      });
    }
  }

  /*
  * Listenes to Tender Id changes
  */
  onSelectEditTenderId(tenderId: string, procureId: number) {
    let found = 0;
    const i = 0;
    this.ratesFrtUpdateList.forEach(e => {
      if (e.procureId === procureId) {
        found = 1;
        e.tenderId = tenderId;
      }
    });
    if (found === 0) {
      this.ratesFrtProcureEditList.forEach(e => {
        if (e.procureId === procureId) {
          e.tenderId = tenderId;
          this.ratesFrtUpdateList.push(e);
        }
      });
    }
  }

  /*
  ** Listens to Ltl Surcharge changes
  */
  onSelectEditLtlSurCharge(ltlSurCharge: number, procureId: number) {
    let found = 0;
    const i = 0;
    this.ratesFrtUpdateList.forEach(e => {
      if (e.procureId === procureId) {
        found = 1;
        e.ltlSurchargePct = ltlSurCharge;
      }
    });
    if (found === 0) {
      this.ratesFrtProcureEditList.forEach(e => {
        if (e.procureId === procureId) {
          e.ltlSurchargePct = ltlSurCharge;
          this.ratesFrtUpdateList.push(e);
        }
      });
    }
  }

  /*
  ** Listens to Ltl Min Chrage changes
  */
  onSelectEditLtlMinCharge(ltlMinCharge: number, procureId: number) {
    let found = 0;
    const i = 0;
    this.ratesFrtUpdateList.forEach(e => {
      if (e.procureId === procureId) {
        found = 1;
        e.ltlMinimumChargePct = ltlMinCharge;
      }
    });
    if (found === 0) {
      this.ratesFrtProcureEditList.forEach(e => {
        if (e.procureId === procureId) {
          e.ltlMinimumChargePct = ltlMinCharge;
          this.ratesFrtUpdateList.push(e);
        }
      });
    }
  }

  /*
  ** Listenes to Tl Rate Amount changes
  */
  onSelectEditTlRateAmt(tlRateAmt: number, procureId: number) {
    let found = 0;
    const i = 0;
    this.ratesFrtUpdateList.forEach(e => {
      if (e.procureId === procureId) {
        found = 1;
        e.tlRateAmount = tlRateAmt;
      }
    });
    if (found === 0) {
      this.ratesFrtProcureEditList.forEach(e => {
        if (e.procureId === procureId) {
          e.tlRateAmount = tlRateAmt;
          this.ratesFrtUpdateList.push(e);
        }
      });
    }
  }

  /*
  ** Listens to Tl Min Charge changes
  */
  onSelectEditTlMinCharge(tlMinCharge: number, procureId: number) {
    let found = 0;
    const i = 0;
    this.ratesFrtUpdateList.forEach(e => {
      if (e.procureId === procureId) {
        found = 1;
        e.tlMinimumCharge = tlMinCharge;
      }
    });
    if (found === 0) {
      this.ratesFrtProcureEditList.forEach(e => {
        if (e.procureId === procureId) {
          e.tlMinimumCharge = tlMinCharge;
          this.ratesFrtUpdateList.push(e);
        }
      });
    }
  }

  /*
  ** Binds the data from the service to the FormArray.
  */

  setupRateControlsTable(rhprecords: any) {
    const len = (<UntypedFormArray>this.frtViewRatesFormGroup.get('rateTableControls')).length;
    while ((<UntypedFormArray>this.frtViewRatesFormGroup.get('rateTableControls')).length !== 0) {
      (<UntypedFormArray>this.frtViewRatesFormGroup.get('rateTableControls')).removeAt(0);
    }

    for (const rhprecord of rhprecords) {
      const grp = this.fb.group({
        Delete: [''],
        Status: [rhprecord.updateFlag],
        Date: [rhprecord.updateDate],
        Type: [rhprecord.rateTypeId],
        Origin: [rhprecord.originName],
        Destination: [rhprecord.destinationName],
        TenderId: [rhprecord.tenderId, [Validators.required, Validators.minLength(4), Validators.maxLength(4), Validators.pattern('^[a-zA-Z0-9]+$')]],
        ltlSurCharge: [rhprecord.ltlSurchargePercent, [Validators.pattern('^-?[0-9]\\d*(\\.\\d{1,2})?$'), ltlSurChargeValidator(rhprecord.rateTypeId, rhprecord.ltlMinimumChargePercent, rhprecord.ltlMax)]],
        ltlMinCharge: [rhprecord.ltlMinimumChargePercent, [Validators.pattern('^-?[0-9]\\d*(\\.\\d{1,2})?$'), ltlMinChargeValidator(rhprecord.rateTypeId, rhprecord.ltlMin)]],
        tlRateAmt: [rhprecord.tlRateAmount, [Validators.pattern('^-?[0-9]\\d*(\\.\\d{1,2})?$'), tlRateAmountValidator(rhprecord.rateTypeId, rhprecord.tlMinimumCharge, rhprecord.tlMax)]],
        tlMinCharge: [rhprecord.tlMinimumCharge, [Validators.pattern('^-?[0-9]\\d*(\\.\\d{1,2})?$'), tlMinChargeValidator(rhprecord.rateTypeId, rhprecord.tlMin)]],
        ProcureId: [rhprecord.procureId],
        ltlSurChgLimit: [rhprecord.ltlMax],
        ltlMinChgLimit: [rhprecord.ltlMin],
        tlRateAmtLimit: [rhprecord.tlMax],
        tlMinChgLimit: [rhprecord.tlMin]
      });
      grp.get('Date').setValue(new DateFormatPipe().transform(grp.get('Date').value));
      (<UntypedFormArray>this.frtViewRatesFormGroup.get('rateTableControls')).push(grp);
    }
  }

// Set Up Pagination Map
  setupPagination() {
    this.pageMap = new Map<number, any>();
    let pageCount = 1;

    for (let i = 0; i < this.totalItems; i = i + this.itemsPerPage) {
      const pageOfHhgRateEdit = this.ratesFrtProcureEditList.slice(i, i + this.itemsPerPage);
      this.pageMap.set(pageCount, pageOfHhgRateEdit);
      pageCount++;
    }
    this.totalPages = pageCount - 1;
    // Reset the current page to the first page
    this.currentPage = 1;
    this.resultsPage = this.pageMap.get(this.currentPage);
    if (this.currentPage === 1) {
      this.setupRateControlsTable(this.resultsPage);
    }
    this.showingStart = 1;
    const end = this.currentPage * this.itemsPerPage;
    if (end > this.totalItems) {
      this.showingEnd = this.totalItems;
    } else {
      this.showingEnd = end;
    }
  }

  page(currentPage: number) {
    this.currentPage = currentPage;
    if (this.resultsPage != null && this.resultsPage.length !== 0) {
      this.resultsPage = this.pageMap.get(currentPage);
      if (this.currentPage > 0) {
        this.setupRateControlsTable(this.resultsPage);
      }
    }
    const end = this.currentPage * this.itemsPerPage;
    if (end > this.totalItems) {
      this.showingEnd = this.totalItems;
    } else {
      this.showingEnd = end;
    }
    this.showingStart = (this.currentPage * this.itemsPerPage) - this.itemsPerPage + 1;
  }

  itemsPerPageChanged(itemsPerPage: any) {
    this.itemsPerPage = itemsPerPage;
    if (this.resultsPage != null && this.resultsPage.length !== 0) {
      this.setupPagination();
      this.pageReset = true;
    }
  }

  /**
   * @description opens accessorials modal with modify/delete options
   */
  openAccessorials() {
    const initialState = {
      carrierId: this.carrierId,
      sroMasterId: this.sroMasterId,
      rateTypeId: this.getFormField('rateType').value,

    };
    this.bsModalRef = this.modalService.show(FrtEditRatesAccessorialsComponent, {initialState, class: 'modal-lg'});
    this.bsModalRef.content.closeBtnName = 'Close';
  }

  /**
   * @description unsubscribes to the user subscription.
   */
  ngOnDestroy() {
    this.observer$.next(false);
  }

}
